module.exports = __webpack_public_path__ + "investment-roi.1RX4ggdH.svg";